import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <IndexSection />
        <CarouselSection />
        <FaqSection />
        <CommentsSection />
        <FeaturesSection />
        <TopicsSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <MediaSection />
        <AppSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}